import React from 'react';
import './SearchForm.css';

export default function ToggleButtons({name, buttons, value, onChange}) {
    return (
        <div className="btn-group btn-group-toggle">
            {buttons.map(item => {
                const isSelected = (item.value === value);
                return (
                    <label key={item.value}
                           className={"btn btn-secondary " + (isSelected?'active':'')}>
                        <input type="radio"
                               name={name}
                               autoComplete="off"
                               value={item.value}
                               checked={isSelected}
                               onChange={() => {
                                   onChange(item.value);
                               }}
                        />
                        {item.label}
                    </label>
                );
            })}
        </div>
    );
}